import React from 'react';

export function createNamedContext<T>(
  contextDefaultByName: Record<string, T | undefined>
): React.Context<T | undefined> {
  const entries = Object.entries(contextDefaultByName);
  if (entries.length !== 1) {
    throw new Error('createNamedContext requires exactly one named default value.');
  }

  const [name, defaultValue] = entries[0];
  const context = React.createContext<T | undefined>(defaultValue);
  context.displayName = name;
  return context;
}

export function useRequiredContext<T>(context: React.Context<T | undefined>): T {
  const value = React.useContext(context);
  if (value === undefined) {
    const name = context.displayName ?? 'Context';
    throw new Error(`${name} must be used within its provider.`);
  }
  return value;
}
